function dialogWidth () {
  switch (this.$vuetify.breakpoint.name) {
    case "xs":
    case "sm": return "98vw"
    default: return "50vw"
  }
}

var dataTableHeight = "calc(100vh - 256px)"

export { dialogWidth, dataTableHeight }
